import { get, del, post, put } from "./base";

export function deleteWebhook(webhookId) {
  return del(`/webhooks/${webhookId}`);
}

export function createWebhook(data) {
  return post("/webhooks", data);
}

export function updateWebhook(webhookId, data) {
  return put(`/webhooks/${webhookId}`, data);
}

export function getWebhook(id) {
  return get(`/webhooks/${id}`);
}

export function getWebhooks(params = {}) {
  const query = new URLSearchParams(params).toString();
  const url = `/webhooks${query ? `?${query}` : ""}`;
  console.log("🔍 Fetching URL:", url);  // ADD THIS
  return get(url);
}